import React from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import { AssessmentEditorComponent } from '../components/AssessmentEditorComponent';
import { DraftEditorComponent } from '../components/DraftEditorComponent';
import AssessmentsDashboard from './AssessmentsDashboard';
import AssessmentCreator from './AssessmentCreator';
import PrivateRoute from 'js/containers/Route/PrivateRoute';
import Dashboard from 'js/layouts/Dashboard';
import MinimalLayout from 'js/layouts/Minimal';
import Workspace from 'js/containers/Route/Workspace';

function AssessmentManagement({ ...props }) {
  const match = useRouteMatch();
  return (
    <Workspace {...props}>
      <Switch>
        <PrivateRoute
          path={`${match.path}/new`}
          component={AssessmentCreator}
          layout={Dashboard}
        />
        <PrivateRoute
          path={`${match.path}/drafts/:draftId/edit`}
          component={DraftEditorComponent}
          layout={MinimalLayout}
        />
        <PrivateRoute
          path={`${match.path}/:templateId/edit`}
          component={AssessmentEditorComponent}
          layout={MinimalLayout}
        />
        <PrivateRoute
          path={match.path}
          exact
          component={AssessmentsDashboard}
          layout={Dashboard}
        />
      </Switch>
    </Workspace>
  );
}

export default AssessmentManagement;
